import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const TooltipChild = styled(Box).attrs(() => ({
  position: 'absolute',
  color: 'background',
  bg: 'primaryText',
  borderRadius: '5px',
  p: '10px',
}))`
  ${({ overlapCompensation }) => `
  width: max-content;
  display: flex;
  visibility: hidden;
  white-space: nowrap;
  z-index: 3;
  transform: translateX(calc(-50% - ${overlapCompensation}px));
  `}
`;

export const Container = styled(Box).attrs(({ isCollapsed }) => ({
  backgroundColor: 'foreground',
  justify: isCollapsed ? 'flex-start' : 'flex-end',
  align: isCollapsed ? 'flex-start' : 'center',
  pr: 3,
  horizontal: !isCollapsed,
}))`
  ${({ isCollapsed }) =>
    isCollapsed &&
    `
    height: 100%;
    gap: 8px;
    padding-top: 16px;

    > * {
      margin-top: 0;
    }

    > #action-bar-item-collapse {
      margin-top: 10px;
    }

    ${TooltipChild} {
      bottom: auto;
      left: 110%;
      top: 50%;
      transform: translateY(-50%);
    }
  `}

  ${({ isCollapsed }) =>
    !isCollapsed &&
    `
    > * {
      margin-left: 2px;
    }

    > #action-bar-item-collapse {
      margin-left: 10px;
      margin-right: auto;

      @media (max-width: ${BP_LAPTOP}px) {
        display: none;
      }

      ${TooltipChild} {
        bottom: auto;
        left: 110%;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    ${TooltipChild} {
      bottom: 110%;
      left: 50%;
    }
  `}
`;

export const IconWrapper = styled(Box).attrs(
  ({ isActive, iconWidth, color = 'secondaryLink' }) => ({
    color: isActive ? 'primaryBase' : color,
    backgroundColor: 'foreground',
    justify: 'center',
    align: 'center',
    width: iconWidth,
    flexDirection: 'column',
    gap: '4px',
  }),
)`
  cursor: pointer;
`;

export const ToolTip = styled(Box).attrs(() => ({
  position: 'relative',
}))`
  &:hover ${TooltipChild} {
    visibility: visible;
  }
`;

export const Spacer = styled(Box).attrs({
  height: '10px',
})``;
